import MuiPagination from "@mui/material/Pagination";
import React from "react";

interface PaginationControlsProps {
  count: number;
  page: number;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

const PaginationControls = ({ count, page, onPageChange }: PaginationControlsProps) => {
  return (
    <MuiPagination
      count={count}
      page={page}
      onChange={onPageChange}
      color="primary"
      shape="rounded"
      siblingCount={0}
      sx={(theme) => ({
        '& .MuiPaginationItem-previousNext': {
          color: 'primary.main'
        },
        '& .MuiPaginationItem-root': {
          borderRadius: 2,
          backgroundColor: 'grey.400',
          width: 32,
          height: 32,
          p: 1
        },
        '& .MuiPaginationItem-page': {
          ...theme.typography.p3,
          '&.Mui-selected': {
            backgroundColor: 'primary.main',
          }
        }
      })}
    />
  );
};

export default PaginationControls;
